import { Action, creator } from 'src/config/rootAction';

import {
    ChangeCorePillarsRatingActionArguments,
    CorePillarsRatingRequestData,
} from '../models/weekShared';

export const FETCH_CORE_PILLARS_RATING_SUCCEEDED = 'FETCH_CORE_PILLARS_RATING_SUCCEEDED';
export type FetchCorePillarsRatingSuccessAction = Action<
    typeof FETCH_CORE_PILLARS_RATING_SUCCEEDED,
    CorePillarsRatingRequestData
>;
export const fetchCorePillarsRatingSuccess = creator<FetchCorePillarsRatingSuccessAction>(
    FETCH_CORE_PILLARS_RATING_SUCCEEDED,
);

export const FETCH_CORE_PILLARS_RATING_FAILED = 'FETCH_CORE_PILLARS_RATING_FAILED';
export type FetchCorePillarsRatingFailAction = Action<typeof FETCH_CORE_PILLARS_RATING_FAILED>;
export const fetchCorePillarsRatingFail = creator<FetchCorePillarsRatingFailAction>(
    FETCH_CORE_PILLARS_RATING_FAILED,
);

export const CHANGE_CORE_PILLAR_RATING = 'CHANGE_CORE_PILLAR_RATING';
export type ChangeCorePillarRatingAction = Action<
    typeof CHANGE_CORE_PILLAR_RATING,
    ChangeCorePillarsRatingActionArguments
>;
export const changeCorePillarRating = creator<ChangeCorePillarRatingAction>(
    CHANGE_CORE_PILLAR_RATING,
);

export const SUBMIT_CORE_PILLARS_RATING_FORM_REQUESTED =
    'SUBMIT_CORE_PILLARS_RATING_FORM_REQUESTED';
export type SubmitCorePillarsRatingFormAction = Action<
    typeof SUBMIT_CORE_PILLARS_RATING_FORM_REQUESTED
>;
export const submitCorePillarsRatingForm = creator<SubmitCorePillarsRatingFormAction>(
    SUBMIT_CORE_PILLARS_RATING_FORM_REQUESTED,
);

export const SUBMIT_CORE_PILLARS_RATING_FORM_SUCCEEDED =
    'SUBMIT_CORE_PILLARS_RATING_FORM_SUCCEEDED';
export type SubmitCorePillarsRatingFormSuccessAction = Action<
    typeof SUBMIT_CORE_PILLARS_RATING_FORM_SUCCEEDED
>;
export const submitCorePillarsRatingFormSuccess = creator<SubmitCorePillarsRatingFormSuccessAction>(
    SUBMIT_CORE_PILLARS_RATING_FORM_SUCCEEDED,
);

export const SUBMIT_CORE_PILLARS_RATING_FORM_FAILED = 'SUBMIT_CORE_PILLARS_RATING_FORM_FAILED';
export type SubmitCorePillarsRatingFormFailAction = Action<
    typeof SUBMIT_CORE_PILLARS_RATING_FORM_FAILED
>;
export const submitCorePillarsRatingFormFail = creator<SubmitCorePillarsRatingFormFailAction>(
    SUBMIT_CORE_PILLARS_RATING_FORM_FAILED,
);

export type WeekSharedAction =
    | FetchCorePillarsRatingSuccessAction
    | FetchCorePillarsRatingFailAction
    | ChangeCorePillarRatingAction
    | SubmitCorePillarsRatingFormAction
    | SubmitCorePillarsRatingFormSuccessAction
    | SubmitCorePillarsRatingFormFailAction;
